import styled from '@emotion/styled'

import { NavListItemView } from '../../elements/NavListItemView'

export const NavListWithCheckboxWrapper = styled(NavListItemView)`
  height: auto;
`
